/**
 * Idempotency keys for quantity-changing inventory writes
 * (CHG-2026-09-pos-sale-ingest-integrity, D6).
 *
 * The server rejects a RECEIVE or a transfer without a key and books at most one movement per key,
 * so a retried submit after a timeout can never double-book. The key belongs to the submission, not
 * to the request: hold it in a ref, reuse it while retrying the same submission, and drop it once
 * the submission succeeded.
 */

/**
 * A fresh key. `crypto.randomUUID` needs a secure context, which the backoffice always has in
 * production but not in every dev host or test environment, hence the fallback — the value only has
 * to be unique per device, not unguessable.
 */
export function newIdempotencyKey(): string {
  // Typed loosely on purpose: `randomUUID` is declared as always present, but it is absent in an
  // insecure context and in some test environments.
  const host = globalThis as { crypto?: { randomUUID?: () => string } }
  if (typeof host.crypto?.randomUUID === 'function') {
    return host.crypto.randomUUID()
  }
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`
}
